import React from 'react';

interface CapacitorProps {
    x: number;
    y: number;
    rotation?: number;
    value?: number;
    width?: number;
}

export const Capacitor: React.FC<CapacitorProps> = ({
    x,
    y,
    rotation = 0,
    width = 50
}) => {
    const halfWidth = width / 2;
    const leadLength = (width - 20) / 2; // Gap is 20px

    const pathData = `
    M ${-halfWidth} 0 L ${-halfWidth + leadLength} 0
    M ${-4} ${-12} L ${-4} ${12}
    M ${4} ${-12} L ${4} ${12}
    M ${halfWidth - leadLength} 0 L ${halfWidth} 0
  `;

    return (
        <g transform={`translate(${x}, ${y}) rotate(${rotation})`}>
            <path d={pathData} stroke="#1a1a1a" strokeWidth="2" fill="none" strokeLinecap="round" />
        </g>
    );
};
